import { useState, useEffect } from 'react';
import { EXTRA_SERVICES_PRICE_TYPES } from '../../constants';

export function useSelectedOptionals(optionals, cart) {
  const [selectedOptionals, setSelectedOptionals] = useState({});
  useEffect(() => {
    //init selectedOptionals with the optional already in the cart (Eg: in case of page-refresh)
    if (optionals && cart) {
      const initializedStructure = optionals.reduce(
        (acc, availableOptional) => {
          //search for a selectable optional already in the cart
          const optionalValueInsideCart = cart.optionals.find(
            (optionalInCart) => optionalInCart.id === availableOptional.id
          );
          const status = (function () {
            if (optionalValueInsideCart !== undefined) {
              return availableOptional.priceType ===
                EXTRA_SERVICES_PRICE_TYPES.PERSON
                ? parseFloat(optionalValueInsideCart.quantity)
                : true;
            } else {
              return availableOptional.priceType ===
                EXTRA_SERVICES_PRICE_TYPES.PERSON
                ? 0
                : false;
            }
          })();
          return { ...acc, [availableOptional.id]: { status } };
        },
        {}
      );
      setSelectedOptionals(initializedStructure);
    }
  }, [cart, optionals]);
  return [selectedOptionals, setSelectedOptionals];
}
